import { render, staticRenderFns } from "./AssessmentGroupCompEgrProTable.vue?vue&type=template&id=2ab5c053&scoped=true"
import script from "./AssessmentGroupCompEgrProTable.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupCompEgrProTable.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupCompEgrProTable.vue?vue&type=style&index=0&id=2ab5c053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5c053",
  null
  
)

export default component.exports